export default __webpack_public_path__ + "static/media/news2.8b8dfb0b.webp";